'use client'

import { Step } from '@/models/Form'
import { Divider, Flex } from 'antd'
import { CSSProperties, Fragment } from 'react'
import { SBDynamicFormSection } from './SBDynamicFormSection'

interface Props {
  step: Step
  flexStyle?: CSSProperties
}

const SBDynamicFormStep = ({ step, flexStyle }: Props) => {
  // Skip sections with no items to display (e.g. all questions soft-deleted),
  // so dividers are only drawn between sections that actually render.
  const visibleSections = step.sections.filter(
    (section) => section.items.length > 0
  )

  return (
    <Flex vertical style={flexStyle}>
      {visibleSections.map((section, index) => (
        <Fragment key={section.id}>
          <SBDynamicFormSection
            section={section}
            pathPrefix={step.pathPrefix}
          />
          {index < visibleSections.length - 1 && <Divider />}
        </Fragment>
      ))}
    </Flex>
  )
}

type SBDynamicFormStepType = {
  Step: typeof SBDynamicFormStep
}

export { SBDynamicFormStep, type SBDynamicFormStepType }
